import OneSignal from 'react-onesignal';
import { type IInitObject } from 'react-onesignal';

let initPromise: Promise<void> | null = null;
const pendingQueue: Array<() => void> = [];

export function initOneSignal(config: IInitObject): void {
  initPromise = OneSignal.init(config).catch(() => {});
  initPromise.then(() => {
    while (pendingQueue.length > 0) {
      try {
        pendingQueue.shift()?.();
      } catch {
        // noop
      }
    }
  });
}

export function trackOneSignalEvent(name: string, properties?: Record<string, unknown>): void {
  const doTrack = () => {
    try {
      OneSignal.User.trackEvent(name, properties);
    } catch {
      // noop
    }
  };

  if (initPromise) {
    initPromise.then(doTrack).catch(() => {});
  } else {
    pendingQueue.push(doTrack);
  }
}
